import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { useMobile } from '../../../hooks/useMobile';
import { ScrollContainer } from '../../scroll-container/ScrollContainer';
import styles from './WindowBody.module.scss';

export const WindowBody = ({ children, className, disableScroll, fullWidth }: Props) => {

    const isMobile = useMobile();
    const windowClassName = classNames(styles.container, className, {
        [styles.desktop]: !isMobile,
        [styles.fullWidth]: fullWidth
    });

    return (
        <div className={windowClassName}>
            {disableScroll ? (
                <>{children}</>
            ) : (
                <ScrollContainer maxHeight='100%'>
                    {children}
                </ScrollContainer>
            )}
        </div>
    );
};

type Props = {
    children?: ReactNode | undefined;
    className?: string;
    disableScroll?: boolean;
    fullWidth?: boolean;
};